import script from "./InviteUsersStep.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteUsersStep.vue?vue&type=script&setup=true&lang=js"

import "./InviteUsersStep.vue?vue&type=style&index=0&id=2a2dba7e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2dba7e"]])

export default __exports__